import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { getIsPositionAtRiskOfLiquidation, getIsPositionUnhealthy } from '@morpho-org/dapp-core';
import { Skeleton } from '@morpho-org/ui-v6/server';
import { cn } from '@morpho-org/ui-v6/utils';
import { useMemo } from 'react';
import { ProtectedLltv, useProtectedLltv } from '@/components/common/AutoDeleverage/ProtectedLltv';
import { formatLtv } from '@/helpers/formatters';
interface MobileMarketHealthProps {
  ltv: bigint;
  lltv: bigint;
  marketId: MarketId;
  chainId: ChainId;
}
export default function MobileMarketHealth(t0) {
  const $ = _c(30);
  const {
    ltv,
    lltv,
    marketId,
    chainId
  } = t0;
  let t1;
  if ($[0] !== chainId || $[1] !== lltv || $[2] !== marketId) {
    t1 = {
      lltv,
      marketId,
      chainId
    };
    $[0] = chainId;
    $[1] = lltv;
    $[2] = marketId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const protectedLltv = useProtectedLltv(t1);
  const isPositionUnhealthy = protectedLltv ? getIsPositionUnhealthy(ltv, protectedLltv) : false;
  const isPositionAtRiskOfLiquidation = protectedLltv ? getIsPositionAtRiskOfLiquidation(ltv, protectedLltv) : false;
  let t2;
  if ($[4] !== ltv) {
    t2 = formatLtv(ltv);
    $[4] = ltv;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const formattedLtv = t2;
  let t3;
  bb0: {
    const percentage = Number(ltv) * 100 / Number(protectedLltv);
    if (percentage < 1) {
      t3 = "1%";
      break bb0;
    }
    if (percentage > 100) {
      t3 = "100%";
      break bb0;
    }
    t3 = `${percentage}%`;
  }
  const healthBarWidth = t3;
  const t4 = isPositionUnhealthy ? "bg-destructive-foreground" : isPositionAtRiskOfLiquidation ? "bg-[#FFA947]" : "bg-success-foreground";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("absolute top-0 left-0 h-full w-full", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== healthBarWidth) {
    t6 = {
      width: healthBarWidth
    };
    $[8] = healthBarWidth;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="bg-muted relative h-[5px] w-full overflow-hidden rounded-[5px]"><div className={t5} style={t6} /></div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-3xs text-secondary-foreground" style={{
      lineHeight: "normal"
    }}>LTV:{" "}</span>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      lineHeight: "normal"
    };
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== formattedLtv) {
    t10 = <div>{t8}<span className="text-3xs text-foreground" style={t9}>{formattedLtv}</span></div>;
    $[15] = formattedLtv;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-3xs text-secondary-foreground" style={{
      lineHeight: "normal"
    }}>LLTV:</span>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      lineHeight: "normal"
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Skeleton className="h-[14px] w-[30px] rounded-[20px]" />;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== chainId || $[21] !== marketId || $[22] !== protectedLltv) {
    t14 = <div className="gap-2xs flex items-center">{t11}<span className="text-3xs text-foreground" style={t12}><ProtectedLltv lltv={protectedLltv} marketId={marketId} chainId={chainId} tooltip="Auto-Deleverage is active" skeleton={t13} /></span></div>;
    $[20] = chainId;
    $[21] = marketId;
    $[22] = protectedLltv;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t10 || $[25] !== t14) {
    t15 = <div className="gap-2xs flex items-center justify-between">{t10}{t14}</div>;
    $[24] = t10;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15 || $[28] !== t7) {
    t16 = <div className="gap-sm flex flex-col">{t7}{t15}</div>;
    $[27] = t15;
    $[28] = t7;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
}